
import { Options } from "vue-class-component";

import BasePage from "@/common/BasePage";
import AppUtil from "@/util/AppUtil";

@Options({
  components: {},
})
/**托管超级会员 */
export default class ShareholderList extends BasePage {
  // reqUrl = "/zhStaff/staff/getShareholderList";
  //   finished = true;
  _title = "托管超级会员";
  list: any[] = [];
  //    reqData={page:0,limit:10,orderId}
  mounted() {
    AppUtil.request(
      {
        url: "/zhStaff/staff/getShareholderList",
        method: "POST",
      },
      this.get_list_ok
    );
  }
  get_list_ok(res: any) {
    res.data.map((val: any) => {
      val.thumb = AppUtil.get_thumb(val.shareholderHeadimg);
      val.housekeeperSource == 1
        ? (val.source = "自主招募")
        : (val.source = "后台分配");
    });
    this.list = res.data;
  }
  member_click(item:any){
    this.$router.push({
      path:"/staff/shareholderMembers",
      query:{
        code:item.shareholderId,
        name:item.shareholderName
      }
    })    
  }
}
